import React, {useCallback, useContext, useState} from 'react';
import * as PropTypes from 'prop-types';
import { LocaleContext, ScrollsContext } from 'contexts';
import { FirmScrollsPopup } from 'ati-scrolls-popups';
import {ScrollsPopupStages} from './consts';
import ScrollsPopover from './ScrollsPopover';
import { createPortal } from 'react-dom';

const ScrollsPopoverContainer = ({atiIds, visible, children, onPopoverVisibleChange}) =>{
    const {getScrolls} = useContext(ScrollsContext);
    const locale = useContext(LocaleContext);

    const [scrollPopupState, setScrollPopupState] = useState({visible:false, payload: null,
        stage: ScrollsPopupStages.add});
    const [scrollsPopupChanged, setScrollsPopupChanged] = useState(false);

    const onVisibilityChange = useCallback((visible, event)=> {
        event?.preventDefault();
        onPopoverVisibleChange(visible);
    }, [onPopoverVisibleChange]);

    const onOpenScrollsPopup = useCallback((stage, payload)=>{
        setScrollPopupState({visible: true, stage: stage, payload: payload});
    }, []);

    const onCloseScrollsPopup = useCallback(()=>{
        setScrollPopupState({visible:false, payload: null,
            stage: ScrollsPopupStages.add});
        if(scrollsPopupChanged){
            getScrolls();
            setScrollsPopupChanged(false);
        }
    }, [getScrolls, scrollsPopupChanged]);

    return (
        <>
            <ScrollsPopover
                atiIds={atiIds}
                scrollsPopupVisible={scrollPopupState.visible}
                visible={visible}
                onOpenScrollsPopup={onOpenScrollsPopup}
                onPopoverVisibleChange={onVisibilityChange}
            >
                {children}
            </ScrollsPopover>
            {scrollPopupState.visible && (
	            createPortal(
		            <FirmScrollsPopup
			            locale={locale}
			            payload={scrollPopupState.payload}
			            stage={scrollPopupState.stage}
			            onClose={onCloseScrollsPopup}
			            onElementAdd={() => setScrollsPopupChanged(true)}
			            onElementDelete={() => setScrollsPopupChanged(true)}
			            onListChange={() => setScrollsPopupChanged(true)}
			            onListCreate={() => setScrollsPopupChanged(true)}
			            onListDelete={() => setScrollsPopupChanged(true)}
		            />,
	            document.body
	            )
            )}
        </>
    );
};
ScrollsPopoverContainer.defaultProps = {
    visible: false
};

export default ScrollsPopoverContainer;

ScrollsPopoverContainer.propTypes ={
    atiIds: PropTypes.arrayOf(PropTypes.string),
    children: PropTypes.node,
    visible: PropTypes.bool,
    onPopoverVisibleChange: PropTypes.func
};

